export default __webpack_public_path__ + "8d7ca85fd38a0b6282d11fcc44fc3c95.svg";